define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/FormData",
	"csi/comm/GetRequest",
	"csi/heading/AggregateController",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/QueryFilterBuilder",
	"Specification/BOM/BOMSectionMixin",
], function(array, declare, lang, FormData, GetRequest, AggregateController, ActionControllerMixin, xml, Query, QueryFilterBuilder, BOMSectionMixin) {

	return declare([AggregateController, ActionControllerMixin, BOMSectionMixin], {
		// String[]: array of materials with which the selected material must be compatible
		_compatibleMaterials: null,


		/**
		 * Filter by season availability if on Style BOM
		 * @override
		 */
		applyActionFilters: function(view) {
			let q = new Query();
			// If bom type has season availability, then filters are already applied in PartMaterialActual.js
			// But, the GO TO Dialog should filter irrespective of BOM type
			if (!this._isSeasonAvailabilityEnforced()) {
				this._applySeasonAvailabilityFilters(q);
			}
			view.relRoot.addQuery(q);
			this.inherited(arguments);
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: add compatibility and query filters for PSPlacement on first page
			var cache = this.getCache();
			var pm = this.getNode();
			var q = new Query();

			q.importQuery(this._actionViewParameters.m_fixedQuery);

			if (index == 0) {
				this._applySeasonAvailabilityFilters(q);
			}

			if (pm && xml.isValidURL(pm.PSPlacement)) {
				// apply query filters
				var psp = cache.getNode(pm.PSPlacement, true);

				if (xml.isValidURL(psp.QueryFilter)) {
					var nodeBOMRevision = this.getParent();
					var nodeBOM = cache.getNode(nodeBOMRevision.__Parent__, true);
					var qf = cache.addNode(psp.QueryFilter, function(req) {
						req.addDependencyPaths(["Child:Operands/Child:DataPointContainer"]);
					});

					QueryFilterBuilder.create(q, qf.$URL, nodeBOM.__Parent__, cache);
				}

				// apply compatibility
				array.forEach(this._compatibleMaterials, function(url) {
					q.RefAttr("MaterialCompatibility", xml.OP_EQUALS, url, "Child:Spec");
				});
			}

			return q;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			if (bFinish) {
				// if finished, track form data to use for writing operations
				this.m_formData = currentPage.getPageData();
				return null;
			} else if (nextPage.getPageData()) {
				// nothing to do if form data already exists for page
				return null;
			}

			// create form data for each page - setNode to wizard view node so that referenced views are found on PSPlacement
			var fd = new FormData(this);
			fd.setNode(wizard.getViewNode());
			fd.m_bSelectOne = true;

			var mat = this.m_formData.getSelectedNode(true);
			if (mat) {
				fd.addAggregatedNode(mat);
			}

			return wizard.setFormDataToPage(nextPage, fd, false);
		},

		toWriter: function() {
			// summary: force immediate publish
			this.m_writer.setCannotCache();
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Determine whether or not a wizard is needed for selecting material
		 */
		async _goToDialog(changed) {
			var pm = this.getNode();
			var psp = this.m_cache.getNode(pm.PSPlacement);

			if (psp?.DependsOn.length) {
				// query for materials with which the selected material must be compatible
				try {
					const res = await new GetRequest("MaterialSpec", "BOMGetPartMaterialDependsOnMaterials")
						.addParameter(xml.PROP_URL_PARENT, pm.__Parent__)
						.addParameter(xml.PROP_URL, pm.$URL)
						.get();

					const a = res.getUrls();

					if (a?.length) {
						this._compatibleMaterials = a;
					}
				} catch (err) {
					// skip
				}
			}

			// If EnforceSeasonAvailability is set on bom type, then need to query for SeasonAvailability
			if (!pm.ForStyle && !this._isSeasonAvailabilityEnforced() || xml.isValidURL(pm.PSPlacement)) {
				this._actionViewParameters.m_viewRef.m_id = this.getParent().$Type == "ApparelBOMRevision" ? "SelectMaterialWizard" : "MaterialsView";
			}

			AggregateController.prototype._goToDialog.call(this);
		}
	});
});